import axios from 'axios';
import config from '../config';

// Fetches build metadata from the BFF's public /release-info endpoint, for
// Settings > About. Never throws — any failure resolves to null so the About
// section can show its own "unavailable" state instead of breaking the modal.
export async function getReleaseInfo() {
  try {
    const { data } = await axios.get(`${config.apiUrl}/release-info`);
    return data ?? null;
  } catch (err) {
    console.error('Failed to fetch release info:', err);
    return null;
  }
}
